const WEATHER_API_KEY = 'ad66c8f75100c9eac782ad81dec0d190';
const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5/weather';

// Course locations
const COURSE_LOCATIONS = {
  'De Bleekloop': { lat: 51.476177712976416, lon: 4.3613838123413835 },
  'De Plantage': { lat: 51.476177712976416, lon: 4.3613838123413835 },
  'Bergvliet': { lat: 51.476177712976416, lon: 4.3613838123413835 }
};

export const getWeatherForCourse = async (courseName) => {
  try {
    const location = COURSE_LOCATIONS[courseName];
    if (!location) {
      console.warn('Unknown course location:', courseName);
      return null;
    }

    const response = await fetch(
      `${WEATHER_API_URL}?lat=${location.lat}&lon=${location.lon}&appid=${WEATHER_API_KEY}&units=metric`
    );

    if (!response.ok) {
      throw new Error('Weather API request failed');
    }

    const data = await response.json();

    return {
      temp: Math.round(data.main.temp),
      feelsLike: Math.round(data.main.feels_like),
      condition: data.weather[0].main,
      description: data.weather[0].description,
      icon: data.weather[0].icon,
      windSpeed: Math.round(data.wind.speed * 3.6), // Convert m/s to km/h
      humidity: data.main.humidity,
      timestamp: Date.now()
    };
  } catch (error) {
    console.error('Error fetching weather:', error);
    return null;
  }
};

export const getWeatherIcon = (condition) => {
  const icons = {
    'Clear': '☀️',
    'Clouds': '☁️',
    'Rain': '🌧️',
    'Drizzle': '🌦️',
    'Thunderstorm': '⛈️',
    'Snow': '❄️',
    'Mist': '🌫️',
    'Fog': '🌫️',
    'Haze': '🌫️'
  };
  return icons[condition] || '🌤️';
};

export const getWeatherEmoji = (temp) => {
  if (temp >= 25) return '🔥';
  if (temp >= 20) return '☀️';
  if (temp >= 15) return '🌤️';
  if (temp >= 10) return '☁️';
  return '🥶';
};